module.exports = __webpack_public_path__ + "static/img/04.965f29ea.png";